var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsdt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "USDT") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kepler-market\\uFF08\\u4E3B\\uFF09",
    transform: "translate(-824.000000, -926.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "USDT",
    transform: "translate(824.000000, 926.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,8 C16,12.4184144 12.4184144,16 8,16 C3.58174268,16 0,12.4184144 0,8 C0,3.58164453 3.58174268,0 8,0 C12.4184144,0 16,3.58164453 16,8",
    id: "Fill-1",
    fill: "#1BA27A"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    fill: "#FFFFFF",
    points: "11.7546438 4.03403159 4.17942279 4.03403159 4.17942279 5.86289465 7.05260175 5.86289465 7.05260175 8.55083576 8.88146481 8.55083576 8.88146481 5.86289465 11.7546438 5.86289465"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.98436559,8.83720166 C5.60758166,8.83720166 3.68065266,8.46103358 3.68065266,7.99692808 C3.68065266,7.53295998 5.60750314,7.15671339 7.98436559,7.15671339 C10.3612084,7.15671339 12.2880785,7.53295998 12.2880785,7.99692808 C12.2880785,8.46103358 10.3612084,8.83720166 7.98436559,8.83720166 M12.816822,8.13701948 C12.816822,7.53863273 10.6532667,7.05358319 7.98436559,7.05358319 C5.3156019,7.05358319 3.15188959,7.53863273 3.15188959,8.13701948 C3.15188959,8.66399632 4.82962981,9.10303573 7.05275878,9.20027726 L7.05275878,13.0590228 L8.88138629,13.0590228 L8.88138629,9.20180831 C11.121612,9.10757 12.816822,8.66668548 12.816822,8.13701948",
    id: "Fill-3",
    fill: "#FFFFFF"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/USDT.773be946f3add96505a6756eb0f5d01f.svg";
export { ForwardRef as ReactComponent };